module.exports = __webpack_public_path__ + "img/碳标签简介.71b77041.png";